import { ListResponse } from '@/core/types/ListResponse.ts'
import { DailyCutListResponse } from '@/modules/allies/dailyCut/types/apiValidationSchemas.ts'
import {
  DailyCollectionListResponse,
  SalesDetailListResponse
} from '@/modules/allies/dailyCut/services/apiValidationSchemas.ts'
import { ChangedArticle } from '@/modules/allies/dailyCut/components/dailyCutTabs/tabs/dailyCut/components/otherOperations/columns/changedArticleColumns.tsx'
import { EditedArticle } from '@/modules/allies/dailyCut/components/dailyCutTabs/tabs/dailyCut/components/otherOperations/columns/editedArticleColumns.tsx'
import { DeletedArticle } from '@/modules/allies/dailyCut/components/dailyCutTabs/tabs/dailyCut/components/otherOperations/columns/deletedArticleColumns.tsx'

export const dailyCut: { data: DailyCutListResponse; message: string } = {
  message: 'OK',
  data: {
    results: [
      {
        id: '3',
        commercialAllyId: 1,
        cutDate: '08/09/2025',
        commercialAllyName: 'Distribuidora del Este',
        productsSoldQuantity: 2,
        productsSoldAmount: '240.00',
        productsSoldCommission: '3.00',
        productsReturnAmount: '0.00',
        productsReturnCommission: '0.00',
        productsChangeAmount: '0.00',
        productsChangeCommission: '0.00',
        productsEditionAmount: '0.00',
        productsEditionCommission: '0.00',
        quotesFeesAmount: '0.00',
        allyCommission: '2.50',
        income: '120.00',
        expenses: '3.00'
      },
      {
        id: '5',
        commercialAllyId: 1,
        cutDate: '12/09/2025',
        commercialAllyName: 'Distribuidora del Este',
        productsSoldQuantity: 0,
        productsSoldAmount: '0.00',
        productsSoldCommission: '0.00',
        productsReturnAmount: '0.00',
        productsReturnCommission: '0.00',
        productsChangeAmount: '452.25',
        productsChangeCommission: '11.31',
        productsEditionAmount: '0.00',
        productsEditionCommission: '0.00',
        quotesFeesAmount: '75.00',
        allyCommission: '2.50',
        income: '452.25',
        expenses: '86.31'
      },
      {
        id: '6',
        commercialAllyId: 1,
        cutDate: '15/09/2025',
        commercialAllyName: 'WEPPA',
        productsSoldQuantity: 3,
        productsSoldAmount: '310.00',
        productsSoldCommission: '7.75',
        productsReturnAmount: '0.00',
        productsReturnCommission: '0.00',
        productsChangeAmount: '0.00',
        productsChangeCommission: '0.00',
        productsEditionAmount: '0.00',
        productsEditionCommission: '0.00',
        quotesFeesAmount: '0.00',
        allyCommission: '2.50',
        income: '310.00',
        expenses: '7.75'
      },
      {
        id: '7',
        commercialAllyId: 1,
        cutDate: '16/09/2025',
        commercialAllyName: 'WEPPA',
        productsSoldQuantity: 1,
        productsSoldAmount: '60.00',
        productsSoldCommission: '1.50',
        productsReturnAmount: '0.00',
        productsReturnCommission: '0.00',
        productsChangeAmount: '0.00',
        productsChangeCommission: '0.00',
        productsEditionAmount: '0.00',
        productsEditionCommission: '0.00',
        quotesFeesAmount: '0.00',
        allyCommission: '2.50',
        income: '60.00',
        expenses: '1.50'
      }
    ],
    total: {
      income: '942.25',
      expenses: '98.56'
    },
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 4,
      range: [1],
      count: 4,
      pages: 1,
      total: 4,
      limit: 20
    }
  }
}

export const salesDetails: { data: SalesDetailListResponse; message: string } =
  {
    message: 'OK',
    data: {
      results: [
        {
          id: '1',
          branchOfficeName: 'Sucursal Centro',
          documentNumber: '12345678',
          registerNumber: 'REG001',
          createdAt: '07/09/2025',
          brand: 'Samsung',
          model: 'Galaxy A54',
          imei: '123456789012345',
          cost: 250.0,
          initialTotal: '300.0',
          paymentByQuotes: '50.0',
          paymentWallet: '120.0',
          paymentAlly: '180.0',
          branchOfficeId: '2',
          totalPayment: '100',
          profit: '34',
          rate: '1.8',
          insuranceAmount: '200',
          phone: '325345'
        },
        {
          id: '2',
          branchOfficeName: 'Sucursal Afuera',
          documentNumber: '12345678',
          registerNumber: 'REG001',
          createdAt: '07/09/2025',
          brand: 'Samsung',
          model: 'Galaxy A54',
          imei: '123456789012345',
          cost: 250.0,
          initialTotal: '300.0',
          paymentByQuotes: '50.0',
          paymentWallet: '0.0',
          paymentAlly: '300.0',
          branchOfficeId: '2',
          totalPayment: '90',
          profit: '68',
          rate: '1.8',
          insuranceAmount: '200',
          phone: '325345'
        }
      ],
      total: {
        cost: '610.00',
        initialTotal: '12.25',
        paymentByQuotes: '0.00',
        paymentWallet: '120.00',
        paymentAlly: '480.00',
        totalPayment: '1200',
        profit: '340'
      },
      status: true,
      pagination: {
        next: false,
        prev: false,
        start: 1,
        end: 2,
        range: [1],
        count: 2,
        pages: 1,
        total: 2,
        limit: 20
      }
    }
  }

export const dailyCollections: {
  data: DailyCollectionListResponse
  message: string
} = {
  message: 'OK',
  data: {
    results: [
      {
        id: '38',
        branchOfficeName: 'Plaza Central Este',
        branchOfficeId: '1',
        commercialAllyName: 'WEPPA',
        commercialAllyId: '1',
        documentNumber: '87100925993',
        clientName: 'mi cliente',
        createdAt: '17/09/2025',
        amount: '25.00',
        userName: 'Nestor Test'
      },
      {
        id: '39',
        branchOfficeName: 'Plaza Central Oeste',
        branchOfficeId: '1',
        commercialAllyName: 'WEPPA',
        commercialAllyId: '1',
        documentNumber: '87100925993',
        clientName: 'tu cliente',
        createdAt: '17/09/2025',
        amount: '25.00',
        userName: 'Juan Test'
      }
    ],
    total: {
      amount: '1250.00'
    },
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 2,
      range: [1],
      count: 2,
      pages: 1,
      total: 2,
      limit: 20
    }
  }
}

export const otherOpCreditChange: {
  data: ListResponse<ChangedArticle>
  message: string
} = {
  message: 'OK',
  data: {
    results: [
      {
        oldRegisterNumber: '12245',
        newRegisterNumber: '5675756',
        costDifference: '120',
        createdBy: 'Juana'
      },
      {
        oldRegisterNumber: '09887',
        newRegisterNumber: '19534',
        costDifference: '7',
        createdBy: 'Maria'
      }
    ],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 2,
      range: [1],
      count: 2,
      pages: 1,
      total: 2,
      limit: 20
    }
  }
}

export const otherOpCreditEditing: {
  data: ListResponse<EditedArticle>
  message: string
} = {
  message: 'OK',
  data: {
    results: [
      {
        registerNumber: '56546547',
        amount: '454'
      },
      {
        registerNumber: '09865',
        amount: '19'
      }
    ],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 2,
      range: [1],
      count: 2,
      pages: 1,
      total: 2,
      limit: 20
    }
  }
}

export const otherOpCreditDeletion: {
  data: ListResponse<DeletedArticle>
  message: string
} = {
  message: 'OK',
  data: {
    results: [
      {
        registerNumber: '56546547',
        amount: '120',
        createdBy: 'Juana',
        creditCreateAt: '17/09/2025'
      },
      {
        registerNumber: '09865',
        amount: '19',
        createdBy: 'Juaneta',
        creditCreateAt: '21/09/2025'
      }
    ],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 2,
      range: [1],
      count: 2,
      pages: 1,
      total: 2,
      limit: 20
    }
  }
}

export const cashOutPage1 = {
  data: {
    results: [
      {
        id: '28',
        debt: '330.26',
        amount: '50.00',
        amountBs: null,
        exchange: null,
        status: 'PENDIENTE',
        commercialAllyName: '2S - VERBATIM CEL CA',
        createdAt: '16/10/2025',
        updatedAt: null,
        createdBy: 'Dairo Testv',
        accountNumber: '01021234567890123456'
      },
      {
        id: '27',
        debt: '380.26',
        amount: '50.00',
        amountBs: null,
        exchange: null,
        status: 'PENDIENTE',
        commercialAllyName: '2S - VERBATIM CEL CA',
        createdAt: '16/10/2025',
        updatedAt: null,
        createdBy: 'Dairo Testv',
        accountNumber: '01021234567890123456'
      }
    ],
    total: [],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 2,
      range: [1],
      count: 2,
      pages: 1,
      total: 2,
      limit: 20
    }
  }
}
